import { CommonOptionVM } from "@cmodules/checklist/assets/data/types/vm/template-builder/types/global-options"
import { IScoring } from "./asset"
import { SimpleRuleItem } from "../simple-rule"
import _ from 'lodash'

export class LongTextOptionsVM extends CommonOptionVM {
  required?: boolean
  default_value?: string
  min?: number
  max?: number
  read_only?: boolean
  manual_rating?: boolean
  simple_rule?: SimpleRuleItem[];

  enable_score?: boolean;
  scoring?: IScoring;

  constructor(data: Partial<LongTextOptionsVM> = {}) {
    super(data)
    this.required = data?.required ?? undefined
    this.default_value = data?.default_value || undefined
    this.min = data?.min || undefined
    this.max = data?.max || undefined
    this.read_only = data?.read_only ?? undefined
    this.manual_rating = data?.manual_rating ?? undefined
    this.simple_rule = data.simple_rule ? _.map(data.simple_rule, x => new SimpleRuleItem(x as any)) : undefined

    this.enable_score = data.enable_score ?? undefined
    this.scoring = this.enable_score ? {
      min_point: this.scoring?.min_point ?? 0,
      max_point: this.scoring?.max_point ?? null,
      scoring_weight: this.scoring?.scoring_weight ?? 1
    } : undefined
  }

  validateData() {
    const errors: any[] = []
    if (this.default_value && this.min && this.default_value.length < this.min) {
      errors.push({ key: 'default_value', error_message: `Default value length must be at least ${this.min} characters` })
    }

    if (this.default_value && this.max && this.default_value.length > this.max) {
      errors.push({ key: 'default_value', error_message: `Default value length must not exceed ${this.max} characters` })
    }
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export default LongTextOptionsVM